import React, {Fragment, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNotification} from "../../../ui/notification/NotificationProvider";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import {OrgUnit} from "../../../../models/organization";
import * as _ from "lodash";
import ListItem from "@material-ui/core/ListItem";
import {ListItemText} from "@material-ui/core";
import {OrganizationUnitSelectorDialog} from "../../../_shared/organization-unit-selector/OrganizationUnitSelectorDialog";
import {moveMember} from "../../../../api/organization-unit-functions";

interface Props {
    organizationId: number,
    member: { userId: string, organizationUnitId: number },
    onMoved: () => void,
    onActionCompleted: () => void
}

export const MoveMemberAction: React.FC<Props> = ({organizationId, member, onMoved, onActionCompleted}) => {
    const {t} = useTranslation();
    const [openDestinationOrgUnitSelection, setOpenDestinationOrgUnitSelection] = useState(false);
    const [disable, setDisable] = useState(false);
    const {pushError} = useNotification();
    const {showSuccess} = useApiNotification();

    const move = async (orgUnit: OrgUnit) => {
        setDisable(true);
        await moveMember(
            organizationId,
            member.organizationUnitId,
            orgUnit.id,
            member.userId
        ).then(success => {
            if (success) {
                showSuccess();
                onMoved();
            } else {
                throw new Error()
            }
        }).catch(e => {
            const errorType = _.get(e, 'response.data.error.type') || 'UnknownError';
            pushError({
                message: t(`_Common.Api.Messages.${errorType}`)
            });
        }).finally(() => {
            setOpenDestinationOrgUnitSelection(false);
            onActionCompleted();
        });
    }

    return <Fragment>
        <ListItem onClick={() => setOpenDestinationOrgUnitSelection(true)}>
            <ListItemText style={{cursor: 'pointer'}}>
                {t('Members.Actions.MoveMember.Title')}
            </ListItemText>
        </ListItem>
        <OrganizationUnitSelectorDialog
            open={openDestinationOrgUnitSelection}
            organizationId={organizationId}
            onSelectOrgUnit={move}
            onCancel={() => {
                setOpenDestinationOrgUnitSelection(false);
                onActionCompleted();
            }}
            disabled={disable}
        />
    </Fragment>
}
